export default __webpack_public_path__ + "static/media/bg18.d2d5f812.jpg";